import { Injectable } from '@angular/core';

@Injectable()
export class InspectionConstantsService {

  constructor() { }
  public static InspectionNavigation = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Add Inspection',
        routeURL: '/inspection/add-inspection/new',
        isClickable: true
      },
      {
        routeName: 'Inspections Overview',
        routeURL: '/inspection/inspections-overview',
        isClickable: true
      },
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../../home',
        isClickable: true
      },

      {
        routeName: 'Add Inspection',
        routeURL: '/inspection/add-inspection/new',
        isClickable: true
      },
      {
        routeName: 'Inspections Overview',
        routeURL: '/inspection/inspections-overview',
        isClickable: true
      },
    ],
    ReportRoutes: [
    ]
  };
  public static CheckLitPoints = {
    Description: [
      {
        Id: 1,
        Value: 'IsYes',
      },
      {
        Id: 2,
        Value: 'IsNo',
      },
      {
        Id: 3,
        Value: 'IsNA'
      }
    ]
  };
  public static APIURL = {
    SaveInspection: 'api/task/insertInspectionData',
    GetInspectionData: 'api/task/getInspectionData',
    GetInspectionDataByInspectionRequestId: 'api/task/getInspectionRequestByInspectionRequestId',
    ExportToExcelInspectionData: 'api/task/ExportToExcelInspectionData'
  };
  public static RoutingURLConstant = {
    InspectionOverviewURL: '/inspection/inspections-overview',
    InspectionCardURL: '/inspection/add-inspection/new'
  };
  public static ColumnConstants = {
    ASC: 'ASC',
    DESC: 'DESC',
    InspectionId: 'InspectionId',
    InspectionDate: 'InspectionDate',
    POBListDate: 'POBListDate'
  }
  public static Status = {
    Done: 'Done',
    Cancelled: 'Cancelled',
    Deleted: 'Deleted'
  }
}
